import { useState, Children } from 'react'
import { NoSsr, IconButton, makeStyles } from '@material-ui/core'

import Carousel, {
  arrowsPlugin,
  Dots,
  infinitePlugin,
  slidesToShowPlugin,
  autoplayPlugin,
} from '@brainhubeu/react-carousel'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import '@brainhubeu/react-carousel/lib/style.css'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  denseDots: {
    '& .BrainhubCarousel__dot': {
      padding: 5,
    },
  },
  dots: {
    '& .BrainhubCarousel__dot--selected:before': {
      background: theme.palette.primary.main,
    },
    '& .BrainhubCarousel__dot': {
      opacity: 0.3,
    },
  },
}))

const LeftBtn = ({ disabled }) => (
  <IconButton>
    <ChevronLeftIcon
      fontSize="large"
      color={disabled ? 'disabled' : 'action'}
    />
  </IconButton>
)

const RightBtn = ({ disabled }) => (
  <IconButton>
    <ChevronRightIcon
      fontSize="large"
      color={disabled ? 'disabled' : 'action'}
    />
  </IconButton>
)

const CarouselSp2 = ({
  children,
  slidesPerPage = 1,
  showArrows = false,
  showDots = false,
  finite = false,
  notCentered = false,
  denseDots = false,
  autoPlay = false,
  ...props
}) => {
  
  // if (typeof window === 'undefined') return null

  const [value, setValue] = useState(0)
  const classes = useStyles()

  let pluginsList = []
  pluginsList.push({
    resolve: slidesToShowPlugin,
    options: {
      numberOfSlides: slidesPerPage,
    },
  })
  if (showArrows) {
    pluginsList.push({
      resolve: arrowsPlugin,
      options: {
        arrowLeft: showArrows ? <LeftBtn /> : null,
        arrowLeftDisabled: <LeftBtn disabled />,
        arrowRight: showArrows ? <RightBtn /> : null,
        arrowRightDisabled: <RightBtn disabled />,
        addArrowClickHandler: true,
      },
    })
  }
  if (!finite) {
    pluginsList.push({
      resolve: infinitePlugin,
      options: {
        numberOfInfiniteClones: 1,
      },
    })
  }
  if (!notCentered) {
    pluginsList.push('centered')
  }
  if (autoPlay) {
    pluginsList.push({
      resolve: autoplayPlugin,
      options: {
        interval: 2000,
      },
    })
  }
  pluginsList.push('fastSwipe')

  return (
    <NoSsr>
      <Carousel
        plugins={pluginsList}
        value={value}
        onChange={(value) => setValue(value)}
        {...props}
      >
        {children}
      </Carousel>
      {showDots && (
        <Dots
          value={value}
          onChange={(value) => setValue(value)}
          number={Children.count(children)}
          className={clsx(classes.dots, denseDots && classes.denseDots)}
        />
      )}
    </NoSsr>
  )
}

export default CarouselSp2
